/**
 * Scheduling module constants
 */

export const daysOfWeek = [
  { id: 0, name: 'Monday', short: 'Mon' },
  { id: 1, name: 'Tuesday', short: 'Tue' },
  { id: 2, name: 'Wednesday', short: 'Wed' },
  { id: 3, name: 'Thursday', short: 'Thu' },
  { id: 4, name: 'Friday', short: 'Fri' },
  { id: 5, name: 'Saturday', short: 'Sat' },
  { id: 6, name: 'Sunday', short: 'Sun' },
];

export const visitTypes = [
  { id: 'personal_care', name: 'Personal Care', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  { id: 'medication', name: 'Medication Visit', color: 'bg-purple-100 text-purple-700 border-purple-200' },
  { id: 'domestic', name: 'Domestic Support', color: 'bg-green-100 text-green-700 border-green-200' },
  { id: 'social', name: 'Social Visit', color: 'bg-amber-100 text-amber-700 border-amber-200' },
  { id: 'night_check', name: 'Night Check', color: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
  { id: 'respite', name: 'Respite Care', color: 'bg-pink-100 text-pink-700 border-pink-200' },
];

export const getVisitTypeColor = (type) => {
  const visitType = visitTypes.find(v => v.id === type);
  return visitType?.color || 'bg-slate-100 text-slate-700 border-slate-200';
};

export const getVisitTypeName = (type) => {
  const visitType = visitTypes.find(v => v.id === type);
  return visitType?.name || type;
};
